var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3809 6.93115V19.2202C20.3809 19.348 20.2592 19.4994 20.0674 19.4995H1.90723C1.72029 19.4993 1.59375 19.3525 1.59375 19.2202V6.93115H20.3809ZM7.68066 8.46436C7.00321 8.46455 6.36719 9.00019 6.36719 9.74463V11.3276C6.36721 12.0279 6.95714 12.6067 7.68066 12.6069H14.2939C14.9714 12.6068 15.6074 12.0721 15.6074 11.3276V9.74463C15.6074 9.04429 15.0176 8.46446 14.2939 8.46436H7.68066Z",
    stroke: "#8D8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.813477 0.5H21.1611C21.3355 0.500233 21.4858 0.639097 21.5 0.826172V4.88379H0.5V0.779297C0.50015 0.651578 0.621924 0.500208 0.813477 0.5Z",
    stroke: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThings);
export default __webpack_public_path__ + "static/media/things.3e22e121baf5c65ba04dc363ab8842c8.svg";
export { ForwardRef as ReactComponent };